import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getQuery, getPageIdInfo, loadJS, isZlj, isZZ, compareVersion } from "./common";
import Logger from "./log";
// import lego from '../lego'
import { zzsdk } from "./initLoadSdk";

// 定义输出日志的函数
var logInfo = function logInfo(msg, args) {
  Logger.info('setWebViewPageId: '.concat(msg), args);
};

// 支持状态
var support;

// 判断是否支持setWebViewPageId
var checkSupport = function checkSupport() {
  return new Promise(function (resolve) {
    if (support !== undefined) return resolve(support);
    // 判断端内并且支持setWebViewPageId
    if (window && (window.zhuanzhuanMApplication || window.zhuanzhuanMApplicationIos || window.hmos_bridge_service)) {
      window.__ZZAPP__['hasSupportFeature']({
        method: 'setWebViewPageId'
      }, function (res) {
        if (res && res.code == 1) {
          resolve(support = true);
        } else {
          resolve(support = false);
        }
      });
    } else {
      resolve(support = false);
    }
  });
};

// 设置页面ID
var setPageId = function setPageId(pageId) {
  window.__ZZAPP__.run('setWebViewPageId', {
    pageId: pageId
  }, function (res) {
    if (res && res.code == 0) {
      logInfo('sdk的api回调', res);
    }
  });
  try {
    // 直接获取URL上的查询字符串
    var queryString = window.location.search;
    // 调用setWebViewParams，将查询字符串传递过去
    setWebViewParams({
      pagequery: queryString,
      subpageID: window['zz_lego_backup'].subpageID || '',
      sortId: getQuery('refsortId') || '',
      sectionId: getQuery('refsectionId') || ''
    });
  } catch (error) {}
};

// 加载sdk
var initWebViewPageId = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _getPageIdInfo;
    var _ref2,
      _ref2$pageId,
      pageId,
      isSupport,
      _pageId,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$pageId = _ref2.pageId, pageId = _ref2$pageId === void 0 ? '' : _ref2$pageId;
          _context.next = 3;
          return checkSupport();
        case 3:
          isSupport = _context.sent;
          if (!(isSupport !== true)) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          _pageId = pageId || ((_getPageIdInfo = getPageIdInfo()) === null || _getPageIdInfo === void 0 ? void 0 : _getPageIdInfo.pageId) || '';
          logInfo('pageId:' + _pageId);
          if (_pageId) setPageId(_pageId);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function initWebViewPageId() {
    return _ref.apply(this, arguments);
  };
}();
export var setWebViewPageId = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _ref4,
      _ref4$pageId,
      pageId,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref4$pageId = _ref4.pageId, pageId = _ref4$pageId === void 0 ? '' : _ref4$pageId;
          try {
            if (isZZ() || isZlj()) {
              if (window.__ZZAPP__) {
                initWebViewPageId({
                  pageId: pageId
                });
              } else {
                loadJS(zzsdk, function () {
                  Logger.info('lego加载sdk成功Ocd');
                  initWebViewPageId({
                    pageId: pageId
                  });
                });
              }
            }
          } catch (error) {
            Logger.error("Ocd\u62A5\u9519".concat(error));
          }
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function setWebViewPageId() {
    return _ref3.apply(this, arguments);
  };
}();
export var setWebViewParams = function setWebViewParams(params) {
  try {
    window.__ZZAPP__.run('setWebViewParams', params, function () {
      // console.log('setWebViewParams result:', res)
    });
  } catch (error) {}
};
export var getWebViewRefParams = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          if (!(isZZ() || isZlj())) {
            _context3.next = 10;
            break;
          }
          if (window.__ZZAPP__) {
            _context3.next = 5;
            break;
          }
          _context3.next = 5;
          return loadZZSDK();
        case 5:
          _context3.next = 7;
          return fetchWebViewRefParams();
        case 7:
          return _context3.abrupt("return", _context3.sent);
        case 10:
          return _context3.abrupt("return", {});
        case 11:
          _context3.next = 16;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](0);
          return _context3.abrupt("return", {});
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 13]]);
  }));
  return function getWebViewRefParams() {
    return _ref5.apply(this, arguments);
  };
}();
var loadZZSDK = function loadZZSDK() {
  return new Promise(function (resolve) {
    loadJS(zzsdk, function () {
      Logger.info('lego加载sdk成功Ocd');
      resolve(null);
    });
  });
};
var fetchWebViewRefParams = function fetchWebViewRefParams() {
  var checkSdkSupport = function checkSdkSupport() {
    var zzVersion = navigator.userAgent.match(/zzVersion\/(\S*) zzT/);
    return !!(zzVersion && Array.isArray(zzVersion) && compareVersion(zzVersion[1], '11.5.99') === 1 && (window.zhuanzhuanMApplication || window.zhuanzhuanMApplicationIos));
  };
  return new Promise(function (resolve, reject) {
    try {
      if (checkSdkSupport()) {
        // 如果支持，继续执行获取 WebViewRefParams 的逻辑
        window.__ZZAPP__.run('getWebViewRefParams', {}, function (res) {
          resolve(res);
        });
      } else {
        // 如果不支持，直接返回 false
        resolve({});
      }
    } catch (error) {
      reject(error);
    }
  });
};